import TipsHero from "../components/tips/TipsHero";
import TipsLayout from "../components/tips/TipsLayout";

const Tips = () => {
  return (
    <>
      <TipsHero />

      <TipsLayout />
    </>
  );
};

export default Tips;
